// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/pineseed/v1/address.proto" (package "agency.pineseed.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * ParticipantAddress represents a full participant address.
 * Format: workspace.conversation.thread.participant
 *
 * @generated from protobuf message agency.pineseed.v1.ParticipantAddress
 */
export interface ParticipantAddress {
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 1
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID).
     *
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID).
     *
     * @generated from protobuf field: string thread_id = 3
     */
    threadId: string;
    /**
     * participant_id is the participant identifier (hex fingerprint hash).
     *
     * @generated from protobuf field: string participant_id = 4
     */
    participantId: string;
    /**
     * raw is the formatted address string (required).
     *
     * @generated from protobuf field: string raw = 5
     */
    raw: string;
}
/**
 * ConnectorAddress represents a connector instance address.
 * Format: workspace.channel.group or workspace.channel.group.participant
 *
 * @generated from protobuf message agency.pineseed.v1.ConnectorAddress
 */
export interface ConnectorAddress {
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 1
     */
    workspaceId: string;
    /**
     * channel_id is the channel identifier (UUID).
     *
     * @generated from protobuf field: string channel_id = 2
     */
    channelId: string;
    /**
     * group is the logical grouping identifier.
     *
     * @generated from protobuf field: string group = 3
     */
    group: string;
    /**
     * participant_id is optional for individual participant addressing.
     *
     * @generated from protobuf field: string participant_id = 4
     */
    participantId: string;
    /**
     * tenant is the tenant identifier for multi-tenancy.
     *
     * @generated from protobuf field: string tenant = 5
     */
    tenant: string;
    /**
     * environment is the deployment environment (dev, staging, prod).
     *
     * @generated from protobuf field: string environment = 6
     */
    environment: string;
    /**
     * deployment_tier is the deployment tier.
     *
     * @generated from protobuf field: agency.pineseed.v1.DeploymentTier deployment_tier = 7
     */
    deploymentTier: DeploymentTier;
    /**
     * raw is the formatted address string (required).
     *
     * @generated from protobuf field: string raw = 8
     */
    raw: string;
}
/**
 * ChannelAddress represents a channel name for NATS/WebSocket subscriptions.
 * Supports dynamic channel types via string field for extensibility.
 *
 * @generated from protobuf message agency.pineseed.v1.ChannelAddress
 */
export interface ChannelAddress {
    /**
     * type is the channel type (e.g., "thread", "composing", "typing", "context", "outreach", "organizations", "workspaces", "connections").
     *
     * @generated from protobuf field: string type = 1
     */
    type: string;
    /**
     * workspace_id is the workspace identifier (UUID), optional for system-level channels.
     *
     * @generated from protobuf field: string workspace_id = 2
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID), optional.
     *
     * @generated from protobuf field: string conversation_id = 3
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID), optional.
     *
     * @generated from protobuf field: string thread_id = 4
     */
    threadId: string;
    /**
     * participant_id is the participant identifier, optional for participant-scoped channels.
     *
     * @generated from protobuf field: string participant_id = 5
     */
    participantId: string;
    /**
     * raw is the computed channel name (required).
     *
     * @generated from protobuf field: string raw = 6
     */
    raw: string;
}
/**
 * NatsSubject represents a NATS subject for message routing.
 * Format: stream.base.workspace.conversation.thread
 *
 * @generated from protobuf message agency.pineseed.v1.NatsSubject
 */
export interface NatsSubject {
    /**
     * stream_name is the NATS stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * subject_base is the subject base/prefix.
     *
     * @generated from protobuf field: string subject_base = 2
     */
    subjectBase: string;
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 3
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID).
     *
     * @generated from protobuf field: string conversation_id = 4
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID).
     *
     * @generated from protobuf field: string thread_id = 5
     */
    threadId: string;
    /**
     * raw is the computed NATS subject (required).
     *
     * @generated from protobuf field: string raw = 6
     */
    raw: string;
}
/**
 * ParticipantAddressParseRequest requests parsing of a participant address string.
 *
 * @generated from protobuf message agency.pineseed.v1.ParticipantAddressParseRequest
 */
export interface ParticipantAddressParseRequest {
    /**
     * address is the address string to parse.
     *
     * @generated from protobuf field: string address = 1
     */
    address: string;
    /**
     * validate performs additional validation checks.
     *
     * @generated from protobuf field: bool validate = 2
     */
    validate: boolean;
}
/**
 * ParticipantAddressParseResponse returns the parsed participant address.
 *
 * @generated from protobuf message agency.pineseed.v1.ParticipantAddressParseResponse
 */
export interface ParticipantAddressParseResponse {
    /**
     * address is the parsed participant address.
     *
     * @generated from protobuf field: agency.pineseed.v1.ParticipantAddress address = 1
     */
    address?: ParticipantAddress;
    /**
     * valid indicates if the address is valid.
     *
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * error_message describes parsing or validation errors.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * ParticipantAddressBuildRequest requests construction of a participant address.
 *
 * @generated from protobuf message agency.pineseed.v1.ParticipantAddressBuildRequest
 */
export interface ParticipantAddressBuildRequest {
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 1
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID).
     *
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID).
     *
     * @generated from protobuf field: string thread_id = 3
     */
    threadId: string;
    /**
     * participant_id is the participant identifier (hex fingerprint hash).
     *
     * @generated from protobuf field: string participant_id = 4
     */
    participantId: string;
}
/**
 * ParticipantAddressBuildResponse returns the constructed participant address.
 *
 * @generated from protobuf message agency.pineseed.v1.ParticipantAddressBuildResponse
 */
export interface ParticipantAddressBuildResponse {
    /**
     * address is the constructed participant address.
     *
     * @generated from protobuf field: agency.pineseed.v1.ParticipantAddress address = 1
     */
    address?: ParticipantAddress;
}
/**
 * ConnectorAddressBuildRequest requests construction of a connector address.
 *
 * @generated from protobuf message agency.pineseed.v1.ConnectorAddressBuildRequest
 */
export interface ConnectorAddressBuildRequest {
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 1
     */
    workspaceId: string;
    /**
     * channel_id is the channel identifier (UUID).
     *
     * @generated from protobuf field: string channel_id = 2
     */
    channelId: string;
    /**
     * group is the logical grouping identifier.
     *
     * @generated from protobuf field: string group = 3
     */
    group: string;
    /**
     * participant_id is optional for individual participant addressing.
     *
     * @generated from protobuf field: string participant_id = 4
     */
    participantId: string;
    /**
     * tenant is the tenant identifier for multi-tenancy.
     *
     * @generated from protobuf field: string tenant = 5
     */
    tenant: string;
    /**
     * environment is the deployment environment (dev, staging, prod).
     *
     * @generated from protobuf field: string environment = 6
     */
    environment: string;
    /**
     * deployment_tier is the deployment tier.
     *
     * @generated from protobuf field: agency.pineseed.v1.DeploymentTier deployment_tier = 7
     */
    deploymentTier: DeploymentTier;
}
/**
 * ConnectorAddressBuildResponse returns the constructed connector address.
 *
 * @generated from protobuf message agency.pineseed.v1.ConnectorAddressBuildResponse
 */
export interface ConnectorAddressBuildResponse {
    /**
     * address is the constructed connector address.
     *
     * @generated from protobuf field: agency.pineseed.v1.ConnectorAddress address = 1
     */
    address?: ConnectorAddress;
}
/**
 * ChannelAddressBuildRequest requests construction of a channel address.
 *
 * @generated from protobuf message agency.pineseed.v1.ChannelAddressBuildRequest
 */
export interface ChannelAddressBuildRequest {
    /**
     * type is the channel type.
     *
     * @generated from protobuf field: string type = 1
     */
    type: string;
    /**
     * workspace_id is the workspace identifier (UUID), optional.
     *
     * @generated from protobuf field: string workspace_id = 2
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID), optional.
     *
     * @generated from protobuf field: string conversation_id = 3
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID), optional.
     *
     * @generated from protobuf field: string thread_id = 4
     */
    threadId: string;
    /**
     * participant_id is the participant identifier, optional.
     *
     * @generated from protobuf field: string participant_id = 5
     */
    participantId: string;
}
/**
 * ChannelAddressBuildResponse returns the constructed channel address.
 *
 * @generated from protobuf message agency.pineseed.v1.ChannelAddressBuildResponse
 */
export interface ChannelAddressBuildResponse {
    /**
     * address is the constructed channel address.
     *
     * @generated from protobuf field: agency.pineseed.v1.ChannelAddress address = 1
     */
    address?: ChannelAddress;
}
/**
 * NatsSubjectBuildRequest requests construction of a NATS subject.
 *
 * @generated from protobuf message agency.pineseed.v1.NatsSubjectBuildRequest
 */
export interface NatsSubjectBuildRequest {
    /**
     * stream_name is the NATS stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * subject_base is the subject base/prefix.
     *
     * @generated from protobuf field: string subject_base = 2
     */
    subjectBase: string;
    /**
     * workspace_id is the workspace identifier (UUID).
     *
     * @generated from protobuf field: string workspace_id = 3
     */
    workspaceId: string;
    /**
     * conversation_id is the conversation identifier (UUID).
     *
     * @generated from protobuf field: string conversation_id = 4
     */
    conversationId: string;
    /**
     * thread_id is the thread identifier (UUID).
     *
     * @generated from protobuf field: string thread_id = 5
     */
    threadId: string;
}
/**
 * NatsSubjectBuildResponse returns the constructed NATS subject.
 *
 * @generated from protobuf message agency.pineseed.v1.NatsSubjectBuildResponse
 */
export interface NatsSubjectBuildResponse {
    /**
     * subject is the constructed NATS subject.
     *
     * @generated from protobuf field: agency.pineseed.v1.NatsSubject subject = 1
     */
    subject?: NatsSubject;
}
/**
 * DeploymentTier represents the deployment tier for connector metadata.
 *
 * @generated from protobuf enum agency.pineseed.v1.DeploymentTier
 */
export enum DeploymentTier {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: DEPLOYMENT_TIER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * EDGE represents edge computing nodes.
     *
     * @generated from protobuf enum value: DEPLOYMENT_TIER_EDGE = 1;
     */
    EDGE = 1,
    /**
     * CLOUD represents cloud-hosted nodes.
     *
     * @generated from protobuf enum value: DEPLOYMENT_TIER_CLOUD = 2;
     */
    CLOUD = 2,
    /**
     * LOCAL represents local development nodes.
     *
     * @generated from protobuf enum value: DEPLOYMENT_TIER_LOCAL = 3;
     */
    LOCAL = 3,
    /**
     * ONPREM represents on-premises nodes.
     *
     * @generated from protobuf enum value: DEPLOYMENT_TIER_ONPREM = 4;
     */
    ONPREM = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class ParticipantAddress$Type extends MessageType<ParticipantAddress> {
    constructor() {
        super("agency.pineseed.v1.ParticipantAddress", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 3, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 4, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "32", maxLen: "128", pattern: "^[a-f0-9]{32,128}$" } } } },
            { no: 5, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ParticipantAddress>): ParticipantAddress {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        message.participantId = "";
        message.raw = "";
        if (value !== undefined)
            reflectionMergePartial<ParticipantAddress>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParticipantAddress): ParticipantAddress {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workspace_id */ 1:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 3:
                    message.threadId = reader.string();
                    break;
                case /* string participant_id */ 4:
                    message.participantId = reader.string();
                    break;
                case /* string raw */ 5:
                    message.raw = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParticipantAddress, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workspace_id = 1; */
        if (message.workspaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 3; */
        if (message.threadId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadId);
        /* string participant_id = 4; */
        if (message.participantId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.participantId);
        /* string raw = 5; */
        if (message.raw !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.raw);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ParticipantAddress
 */
export const ParticipantAddress = new ParticipantAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAddress$Type extends MessageType<ConnectorAddress> {
    constructor() {
        super("agency.pineseed.v1.ConnectorAddress", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 2, name: "channel_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 3, name: "group", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "200" } } } },
            { no: 4, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-f0-9]{32,128})?$" } } } },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "environment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 7, name: "deployment_tier", kind: "enum", T: () => ["agency.pineseed.v1.DeploymentTier", DeploymentTier, "DEPLOYMENT_TIER_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAddress>): ConnectorAddress {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceId = "";
        message.channelId = "";
        message.group = "";
        message.participantId = "";
        message.tenant = "";
        message.environment = "";
        message.deploymentTier = 0;
        message.raw = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorAddress>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAddress): ConnectorAddress {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workspace_id */ 1:
                    message.workspaceId = reader.string();
                    break;
                case /* string channel_id */ 2:
                    message.channelId = reader.string();
                    break;
                case /* string group */ 3:
                    message.group = reader.string();
                    break;
                case /* string participant_id */ 4:
                    message.participantId = reader.string();
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                case /* string environment */ 6:
                    message.environment = reader.string();
                    break;
                case /* agency.pineseed.v1.DeploymentTier deployment_tier */ 7:
                    message.deploymentTier = reader.int32();
                    break;
                case /* string raw */ 8:
                    message.raw = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAddress, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workspace_id = 1; */
        if (message.workspaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workspaceId);
        /* string channel_id = 2; */
        if (message.channelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelId);
        /* string group = 3; */
        if (message.group !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.group);
        /* string participant_id = 4; */
        if (message.participantId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.participantId);
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        /* string environment = 6; */
        if (message.environment !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.environment);
        /* agency.pineseed.v1.DeploymentTier deployment_tier = 7; */
        if (message.deploymentTier !== 0)
            writer.tag(7, WireType.Varint).int32(message.deploymentTier);
        /* string raw = 8; */
        if (message.raw !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.raw);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ConnectorAddress
 */
export const ConnectorAddress = new ConnectorAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChannelAddress$Type extends MessageType<ChannelAddress> {
    constructor() {
        super("agency.pineseed.v1.ChannelAddress", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z][a-z0-9_-]*$" } } } },
            { no: 2, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 3, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 4, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 5, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-f0-9]{32,128})?$" } } } },
            { no: 6, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ChannelAddress>): ChannelAddress {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        message.participantId = "";
        message.raw = "";
        if (value !== undefined)
            reflectionMergePartial<ChannelAddress>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChannelAddress): ChannelAddress {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* string workspace_id */ 2:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 3:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 4:
                    message.threadId = reader.string();
                    break;
                case /* string participant_id */ 5:
                    message.participantId = reader.string();
                    break;
                case /* string raw */ 6:
                    message.raw = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChannelAddress, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* string workspace_id = 2; */
        if (message.workspaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 3; */
        if (message.conversationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 4; */
        if (message.threadId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.threadId);
        /* string participant_id = 5; */
        if (message.participantId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.participantId);
        /* string raw = 6; */
        if (message.raw !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.raw);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ChannelAddress
 */
export const ChannelAddress = new ChannelAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NatsSubject$Type extends MessageType<NatsSubject> {
    constructor() {
        super("agency.pineseed.v1.NatsSubject", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "subject_base", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 4, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 5, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 6, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<NatsSubject>): NatsSubject {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.subjectBase = "";
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        message.raw = "";
        if (value !== undefined)
            reflectionMergePartial<NatsSubject>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NatsSubject): NatsSubject {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string subject_base */ 2:
                    message.subjectBase = reader.string();
                    break;
                case /* string workspace_id */ 3:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 4:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 5:
                    message.threadId = reader.string();
                    break;
                case /* string raw */ 6:
                    message.raw = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NatsSubject, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string subject_base = 2; */
        if (message.subjectBase !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subjectBase);
        /* string workspace_id = 3; */
        if (message.workspaceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 4; */
        if (message.conversationId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 5; */
        if (message.threadId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.threadId);
        /* string raw = 6; */
        if (message.raw !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.raw);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.NatsSubject
 */
export const NatsSubject = new NatsSubject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParticipantAddressParseRequest$Type extends MessageType<ParticipantAddressParseRequest> {
    constructor() {
        super("agency.pineseed.v1.ParticipantAddressParseRequest", [
            { no: 1, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 2, name: "validate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ParticipantAddressParseRequest>): ParticipantAddressParseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.address = "";
        message.validate = false;
        if (value !== undefined)
            reflectionMergePartial<ParticipantAddressParseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParticipantAddressParseRequest): ParticipantAddressParseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string address */ 1:
                    message.address = reader.string();
                    break;
                case /* bool validate */ 2:
                    message.validate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParticipantAddressParseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string address = 1; */
        if (message.address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.address);
        /* bool validate = 2; */
        if (message.validate !== false)
            writer.tag(2, WireType.Varint).bool(message.validate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ParticipantAddressParseRequest
 */
export const ParticipantAddressParseRequest = new ParticipantAddressParseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParticipantAddressParseResponse$Type extends MessageType<ParticipantAddressParseResponse> {
    constructor() {
        super("agency.pineseed.v1.ParticipantAddressParseResponse", [
            { no: 1, name: "address", kind: "message", T: () => ParticipantAddress },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ParticipantAddressParseResponse>): ParticipantAddressParseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<ParticipantAddressParseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParticipantAddressParseResponse): ParticipantAddressParseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.pineseed.v1.ParticipantAddress address */ 1:
                    message.address = ParticipantAddress.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParticipantAddressParseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.pineseed.v1.ParticipantAddress address = 1; */
        if (message.address)
            ParticipantAddress.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ParticipantAddressParseResponse
 */
export const ParticipantAddressParseResponse = new ParticipantAddressParseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParticipantAddressBuildRequest$Type extends MessageType<ParticipantAddressBuildRequest> {
    constructor() {
        super("agency.pineseed.v1.ParticipantAddressBuildRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 3, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 4, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "32", maxLen: "128", pattern: "^[a-f0-9]{32,128}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ParticipantAddressBuildRequest>): ParticipantAddressBuildRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        message.participantId = "";
        if (value !== undefined)
            reflectionMergePartial<ParticipantAddressBuildRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParticipantAddressBuildRequest): ParticipantAddressBuildRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workspace_id */ 1:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 3:
                    message.threadId = reader.string();
                    break;
                case /* string participant_id */ 4:
                    message.participantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParticipantAddressBuildRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workspace_id = 1; */
        if (message.workspaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 3; */
        if (message.threadId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.threadId);
        /* string participant_id = 4; */
        if (message.participantId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.participantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ParticipantAddressBuildRequest
 */
export const ParticipantAddressBuildRequest = new ParticipantAddressBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParticipantAddressBuildResponse$Type extends MessageType<ParticipantAddressBuildResponse> {
    constructor() {
        super("agency.pineseed.v1.ParticipantAddressBuildResponse", [
            { no: 1, name: "address", kind: "message", T: () => ParticipantAddress, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ParticipantAddressBuildResponse>): ParticipantAddressBuildResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ParticipantAddressBuildResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParticipantAddressBuildResponse): ParticipantAddressBuildResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.pineseed.v1.ParticipantAddress address */ 1:
                    message.address = ParticipantAddress.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParticipantAddressBuildResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.pineseed.v1.ParticipantAddress address = 1; */
        if (message.address)
            ParticipantAddress.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ParticipantAddressBuildResponse
 */
export const ParticipantAddressBuildResponse = new ParticipantAddressBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAddressBuildRequest$Type extends MessageType<ConnectorAddressBuildRequest> {
    constructor() {
        super("agency.pineseed.v1.ConnectorAddressBuildRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 2, name: "channel_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 3, name: "group", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "200" } } } },
            { no: 4, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-f0-9]{32,128})?$" } } } },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "environment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 7, name: "deployment_tier", kind: "enum", T: () => ["agency.pineseed.v1.DeploymentTier", DeploymentTier, "DEPLOYMENT_TIER_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAddressBuildRequest>): ConnectorAddressBuildRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceId = "";
        message.channelId = "";
        message.group = "";
        message.participantId = "";
        message.tenant = "";
        message.environment = "";
        message.deploymentTier = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectorAddressBuildRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAddressBuildRequest): ConnectorAddressBuildRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workspace_id */ 1:
                    message.workspaceId = reader.string();
                    break;
                case /* string channel_id */ 2:
                    message.channelId = reader.string();
                    break;
                case /* string group */ 3:
                    message.group = reader.string();
                    break;
                case /* string participant_id */ 4:
                    message.participantId = reader.string();
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                case /* string environment */ 6:
                    message.environment = reader.string();
                    break;
                case /* agency.pineseed.v1.DeploymentTier deployment_tier */ 7:
                    message.deploymentTier = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAddressBuildRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workspace_id = 1; */
        if (message.workspaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workspaceId);
        /* string channel_id = 2; */
        if (message.channelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelId);
        /* string group = 3; */
        if (message.group !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.group);
        /* string participant_id = 4; */
        if (message.participantId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.participantId);
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        /* string environment = 6; */
        if (message.environment !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.environment);
        /* agency.pineseed.v1.DeploymentTier deployment_tier = 7; */
        if (message.deploymentTier !== 0)
            writer.tag(7, WireType.Varint).int32(message.deploymentTier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ConnectorAddressBuildRequest
 */
export const ConnectorAddressBuildRequest = new ConnectorAddressBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAddressBuildResponse$Type extends MessageType<ConnectorAddressBuildResponse> {
    constructor() {
        super("agency.pineseed.v1.ConnectorAddressBuildResponse", [
            { no: 1, name: "address", kind: "message", T: () => ConnectorAddress, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAddressBuildResponse>): ConnectorAddressBuildResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAddressBuildResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAddressBuildResponse): ConnectorAddressBuildResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.pineseed.v1.ConnectorAddress address */ 1:
                    message.address = ConnectorAddress.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAddressBuildResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.pineseed.v1.ConnectorAddress address = 1; */
        if (message.address)
            ConnectorAddress.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ConnectorAddressBuildResponse
 */
export const ConnectorAddressBuildResponse = new ConnectorAddressBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChannelAddressBuildRequest$Type extends MessageType<ChannelAddressBuildRequest> {
    constructor() {
        super("agency.pineseed.v1.ChannelAddressBuildRequest", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z][a-z0-9_-]*$" } } } },
            { no: 2, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 3, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 4, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$" } } } },
            { no: 5, name: "participant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-f0-9]{32,128})?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ChannelAddressBuildRequest>): ChannelAddressBuildRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        message.participantId = "";
        if (value !== undefined)
            reflectionMergePartial<ChannelAddressBuildRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChannelAddressBuildRequest): ChannelAddressBuildRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* string workspace_id */ 2:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 3:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 4:
                    message.threadId = reader.string();
                    break;
                case /* string participant_id */ 5:
                    message.participantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChannelAddressBuildRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* string workspace_id = 2; */
        if (message.workspaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 3; */
        if (message.conversationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 4; */
        if (message.threadId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.threadId);
        /* string participant_id = 5; */
        if (message.participantId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.participantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ChannelAddressBuildRequest
 */
export const ChannelAddressBuildRequest = new ChannelAddressBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChannelAddressBuildResponse$Type extends MessageType<ChannelAddressBuildResponse> {
    constructor() {
        super("agency.pineseed.v1.ChannelAddressBuildResponse", [
            { no: 1, name: "address", kind: "message", T: () => ChannelAddress, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ChannelAddressBuildResponse>): ChannelAddressBuildResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ChannelAddressBuildResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChannelAddressBuildResponse): ChannelAddressBuildResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.pineseed.v1.ChannelAddress address */ 1:
                    message.address = ChannelAddress.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChannelAddressBuildResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.pineseed.v1.ChannelAddress address = 1; */
        if (message.address)
            ChannelAddress.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.ChannelAddressBuildResponse
 */
export const ChannelAddressBuildResponse = new ChannelAddressBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NatsSubjectBuildRequest$Type extends MessageType<NatsSubjectBuildRequest> {
    constructor() {
        super("agency.pineseed.v1.NatsSubjectBuildRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "subject_base", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 4, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } },
            { no: 5, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }
        ]);
    }
    create(value?: PartialMessage<NatsSubjectBuildRequest>): NatsSubjectBuildRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.subjectBase = "";
        message.workspaceId = "";
        message.conversationId = "";
        message.threadId = "";
        if (value !== undefined)
            reflectionMergePartial<NatsSubjectBuildRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NatsSubjectBuildRequest): NatsSubjectBuildRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string subject_base */ 2:
                    message.subjectBase = reader.string();
                    break;
                case /* string workspace_id */ 3:
                    message.workspaceId = reader.string();
                    break;
                case /* string conversation_id */ 4:
                    message.conversationId = reader.string();
                    break;
                case /* string thread_id */ 5:
                    message.threadId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NatsSubjectBuildRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string subject_base = 2; */
        if (message.subjectBase !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subjectBase);
        /* string workspace_id = 3; */
        if (message.workspaceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspaceId);
        /* string conversation_id = 4; */
        if (message.conversationId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.conversationId);
        /* string thread_id = 5; */
        if (message.threadId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.threadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.NatsSubjectBuildRequest
 */
export const NatsSubjectBuildRequest = new NatsSubjectBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NatsSubjectBuildResponse$Type extends MessageType<NatsSubjectBuildResponse> {
    constructor() {
        super("agency.pineseed.v1.NatsSubjectBuildResponse", [
            { no: 1, name: "subject", kind: "message", T: () => NatsSubject, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<NatsSubjectBuildResponse>): NatsSubjectBuildResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NatsSubjectBuildResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NatsSubjectBuildResponse): NatsSubjectBuildResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.pineseed.v1.NatsSubject subject */ 1:
                    message.subject = NatsSubject.internalBinaryRead(reader, reader.uint32(), options, message.subject);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NatsSubjectBuildResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.pineseed.v1.NatsSubject subject = 1; */
        if (message.subject)
            NatsSubject.internalBinaryWrite(message.subject, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.pineseed.v1.NatsSubjectBuildResponse
 */
export const NatsSubjectBuildResponse = new NatsSubjectBuildResponse$Type();
